import React from "react";
import PropTypes from "prop-types";
import Tooltip from "material-ui/Tooltip";

const FULL_PERCENT = 100;

const DepartmentPieSection = ({ classes, title, stats }) => {
  if (!stats) return null;

  const palette = ["#4F6BED", "#FF7043", "#2E7D32", "#AB47BC", "#FFCA28"];

  return (
    <div className={classes.categoryBlock}>
      <div className={classes.graphsSectionTitle}>{title}</div>
      <div className={classes.graphsGrid}>
        {Object.keys(stats).map((category) => {
          const tagsObj = stats[category] || {};
          const tagNames = Object.keys(tagsObj);
          if (!tagNames.length) return null;

          // 件数が多い順にソート
          tagNames.sort((a, b) => tagsObj[b] - tagsObj[a]);

          // カテゴリ内の合計件数
          const totalCount = tagNames.reduce(
            (sum, name) => sum + tagsObj[name],
            0
          );

          let currentAngle = 0;
          const segments = [];
          const legendData = [];

          tagNames.forEach((name, index) => {
            const count = tagsObj[name];
            const percent =
              totalCount > 0 ? (count / totalCount) * FULL_PERCENT : 0;
            const percentLabel = Math.round(percent);
            const color = palette[index % palette.length];

            const start = currentAngle;
            const end = currentAngle + percent;
            currentAngle = end;

            segments.push(`${color} ${start}% ${end}%`);
            legendData.push({
              name,
              percentLabel,
              color,
            });
          });

          const gradient = `conic-gradient(${segments.join(", ")})`;

          return (
            <div key={category} className={classes.graphItem}>
              <div className={classes.categoryTitle}>{category}</div>
              <div className={classes.tagStatsList}>
                <div className={classes.pieRow}>
                  <div
                    className={classes.pieChart}
                    style={{ backgroundImage: gradient }}
                  />
                  <div className={classes.legendList}>
                    {legendData.map((item, idx) => (
                      <div
                        key={category + "-legend-" + idx}
                        className={classes.legendRow}
                      >
                        <div
                          className={classes.legendColorBox}
                          style={{ backgroundColor: item.color }}
                        />
                        <div className={classes.legendLabelContainer}>
                          <Tooltip title={item.name}>
                            <div className={classes.legendLabelText}>
                              {item.name}
                            </div>
                          </Tooltip>
                        </div>
                        <div className={classes.legendPercent}>
                          {item.percentLabel}%
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

DepartmentPieSection.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  stats: PropTypes.object,
};

DepartmentPieSection.defaultProps = {
  stats: {},
};

export default DepartmentPieSection;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/DepartmentPieSection.jsx